export const STATION_SIZE = 12;
export const STATION_HALF_SIZE = STATION_SIZE / 2;

export const MIN_DIMENSION = 1;
export const MIN_CANVAS_SIZE = 200;
export const MAX_CANVAS_WIDTH = 1200;
export const MAX_CANVAS_HEIGHT = 900;

// The gutter the editor reserves to the LEFT of its canvas for the y-axis
// labels. It must match PlaneCanvas's `marginLeft` and CanvasAxisLabels'
// `left`, both 40: size the canvas against a smaller number and it overflows
// the gutter and gets clipped by the card's `overflow: hidden`.
export const MARGIN_LEFT = 40;
// Reserved BELOW the canvas for the x-axis labels (PlaneCanvas marginBottom
// 20 + the label's own ~20px, which overlap).
export const MARGIN_TOP = 30;
export const LABEL_WIDTH = 25;
export const LABEL_HEIGHT = 25;
export const CARD_PADDING = 12;
export const CARD_MIN_HEIGHT = 460;

// Height for the Card bodies that host the live canvas. Grows with the
// viewport so a big screen gets a big canvas; the lower bound reproduces the
// old fixed 460px card (i.e. today's canvas size) on short screens.
export const CANVAS_CARD_BODY_HEIGHT = "clamp(460px, 56vh, 720px)";

// 編輯模式 colour, and the one fixed accent of the canvas controls (the 圖層
// switches and map indicator): an antd blue that reads as "on" on every
// company theme, even where the theme's primary is grey.
export const EDIT_COLOR = "#1677ff";

// The site rectangle on every plane canvas (live dashboard and plan editor):
// a darker surround outside the floor and a thin edge around it. A floor with
// no plan image gets the lighter FLOOR_BG sheet; GRID_LINE is the grid.
export const OUTSIDE_FLOOR_BG = "#e4e7ea";
export const FLOOR_EDGE = "#b6bcc3";
export const FLOOR_BG = "#f0f2f5";
export const GRID_LINE = "#dcdfe3";

export const LINE_FIXED_HEIGHT = 200;
export const LINE_MIN_WIDTH = 300;
export const LINE_MAX_WIDTH = 1200;

export const TUNNEL_FIXED_HEIGHT = 300;
export const TUNNEL_MIN_WIDTH = 300;
export const TUNNEL_MAX_WIDTH = 1200;

// Fallback lane "width" (metres) used as the floor height of line/tunnel
// sites that have no declared height (line sites commonly leave it unset).
// It spans lane-gate tripwires ([[x,0],[x,H]]) and gives the viewport a real
// vertical scale, so a line site with no height is still a valid viewport.
export const DEFAULT_LANE_SPAN_M = 4;
